import PRICING from 'src/resources/pricing.hjson';


export default {
	init: false,
	accountHolder: null,
	iban: null,
	last4: null,
	source: null,
	type: 'sepa_debit', // payment-method
	cancellationDate: null,
	invoices: [],
	invoicesLoading: false,
	pricing: PRICING,
	vehicleCount: 29, // for testing purpose only
	// payment
	period: 'yearly',
	product: '',
	stage: 'LT30',
	setupFee: false,
	offer: null,
};
